/** A referential list of contact roles: no tenant, no parameter. */
class FetchContactRoles {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchContactRoles;
